import image1 from '../../assets/photo/fhero_img.png'
export const featureData = [ 
   
    {
        image: 'https://i.im.ge/2022/09/23/10HKGM.fhero-img.png',
        heading: 'Order Food To Your Home Or Office.',
        info: 'Best Cooks and Fast Delivery System. Order Now!'
        
        
    }
  

 


];